import {InitPage} from "../index";

declare var $;
declare var setPrinterUrl;
declare var messageDialogBox;

class RfidTagging {
  init() {
    $(".select-item-all").on("click", () => {
        if ($(".select-item-all:checked").length > 0) {
            $(".select-item").prop("checked", true);
        }
        else {
            $(".select-item").prop("checked", false);
        }
    });

    // When changing the selected printer auto-save it to the server
    $("#printer").change((e) => {
      console.log($(e.target));

      $.ajax({
        url: setPrinterUrl,
        method: 'POST',
        data: {printer: $(e.target).val()}
      }).done((e) => {
        console.log(e);
      });
    });

    $(".edit-btn").on('click', (e) => {
      const url = $(e.target).attr("url");
      $("#pin-auth-dialog #redirect_url").val(url);
      window.PinAuthentication.showPinLogin();
    });

    $('.massActionBtn').on('click', (e) => {
        if (!$("#printer").val()) {
            alert("Please select the proper printer from the drop down menu to continue. WARNING: make sure you select the printer in your area, so that random labels are not printed else where.")

            e.preventDefault();
            e.stopPropagation();
            return false;
        }
      const url = $(e.target).data('url');
      const searchIDs = $(".select-item:checked").map(function () {
        return $(this).val();
      }).get();

      if (searchIDs.length === 0) {
        messageDialogBox('Need to Select minimum 1 Job to perform action');
        return;
      }

      if (url === '<%= destroy_all_client_store_manufacturing_rfid_tagging_index_path(@client, @store) %>') {
        $('#ids').val(searchIDs);
        $('#deleteTagFom').attr('action', url);
        $('#delete_rfid_job').modal('show');
      } else {
        const form = $('<form action="' + url + '" method="post">' +
          '<input type="text" name="ids" value="' + searchIDs + '" />' +
          '<input type="hidden" name="callback_url" value="' + window.location + '">' +
          '</form>');
        $('body').append(form);
        form.submit();
      }
    });

    $('.delete-tag').on('click', (e) => {
      $('#id').val($(e.target).data('id'));
      $('#delete_rfid_job').modal('show');
    });

    $('#enable_zone').on('click', () => {
      RfidTagging.updateRePrintUrl();
    });

    $('#sub_zone_id').on('change', () => {
      RfidTagging.updateRePrintUrl();
    });

    RfidTagging.updateRePrintUrl();
  }

  static updateRePrintUrl() {
    $('.rePrintTag').each((e, i) => {
      $(i).attr('href', $(i).attr('href').split('?')[0])
    })
    if ($('#enable_zone:checked').length > 0) {
      $('.rePrintTag').each((e, i) => {
        $(i).attr('href', $(i).attr('href') + '?sub_zone_id=' + $('#sub_zone_id').val() + '&enable_zone=true')
      });
    }
  };
}

export function LoadPage() {
    InitPage("rfid_tagging", () => {
        const rt = new RfidTagging();
        rt.init();
    });
}
